"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./style/MiniListing.css") : void 0;
var _index = require("../utils/index");
var _config = _interopRequireDefault(require("../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// can remove with triplink-app-flags cleanup

var MiniListing = function MiniListing(_ref) {
  var listing = _ref.listing,
    isLoggedIn = _ref.isLoggedIn,
    _ref$betas = _ref.betas,
    betas = _ref$betas === void 0 ? {
      pathname: _config.default.nui.baseUrl
    } : _ref$betas;
  var miniImage = listing.images.miniImage,
    _listing$localized = listing.localized,
    name = _listing$localized.name,
    title = _listing$localized.title,
    _listing$core = listing.core,
    isUserConnected = _listing$core.isUserConnected,
    icon = _listing$core.icon,
    isTriplinkPreferredApp = _listing$core.isTriplinkPreferredApp,
    categories = _listing$core.categories;

  /** Note: an app can NEVER BE BOTH a triplink and endorsed app at the same time (confirmed by Laurel) */
  var renderLegacyTripLinkPreferredAppLogo = function renderLegacyTripLinkPreferredAppLogo() {
    if ((0, _index.canAccessBeta)(betas, 'triplink-app-flags') && isTriplinkPreferredApp) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "preferred"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "preferred-text"
      }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
        id: "Preferred"
      })));
    }
  };
  var renderEndorsedAppLogo = function renderEndorsedAppLogo() {
    if ((categories || []).includes('ENDORSED_APPS') && ((0, _index.canAccessBeta)(betas, 'endorsed-apps-category') || _config.default.nui.endorsedCategoryEnabled)) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "endorsed"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "endorsed-hover-text"
      }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
        id: "EndorsedHover"
      })), /*#__PURE__*/_react.default.createElement("span", {
        className: "endorsed-text"
      }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
        id: "EndorsedApp"
      })));
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mini-listing"
  }, renderLegacyTripLinkPreferredAppLogo(), renderEndorsedAppLogo(), /*#__PURE__*/_react.default.createElement("img", {
    src: icon || miniImage || '/static/images/brand/logo-SAPConcur-20171204.svg',
    className: "card-image",
    alt: "".concat(name, " icon"),
    loading: "lazy"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "card-text card-title"
  }, name), !isUserConnected ? /*#__PURE__*/_react.default.createElement("div", {
    className: "card-text card-headline"
  }, title) : null, isLoggedIn && isUserConnected ? /*#__PURE__*/_react.default.createElement("span", {
    className: "is-connected-check"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "is-connected-check-details icon-check icon-size-sm"
  }), "\xA0", /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "Connected"
  })) : null);
};
MiniListing.propTypes = {
  listing: _propTypes.default.object.isRequired,
  isLoggedIn: _propTypes.default.bool,
  betas: _propTypes.default.object
};
var _default = exports.default = MiniListing;